// extracted by mini-css-extract-plugin
export default {"CustomWidgetUI":"HsUIWrapper_CustomWidgetUI__Euggf","Hidden":"HsUIWrapper_Hidden__0u614","ShortTitle":"HsUIWrapper_ShortTitle__e1vdz","InsideGroup":"HsUIWrapper_InsideGroup__gLm8g"};